import React from 'react'
import './cs.css'

function CS() {
    return (
        <div>
            
            <div className='CSE-card'>
            <div className='flip-card-CSE'>
                <div className='flip-card-inner-CSE'>
                    <div className='flip-card-front-CSE'>
                        <h1>
                        <br/>
                            Data Structures and Algorithms
                        </h1>
                    </div>
                    <div class="flip-card-back-CSE">
                        <h3>
                        
                            <a href='https://www.youtube.com/watch?v=xLetJpcjHS0&list=PLBlnK6fEyqRj9lld8sWIUNwlKfdUoPd1Y'>Video Resource 1</a>
                            <br/>
                            <a href='https://www.youtube.com/watch?v=_pNbraaaJW4&list=PLfc1-isKPs7ID3nuYbLZEFjCNQVkmuJPA'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://1lib.in/book/2089156/1e610b'>Data Structures and Algorithms in Python</a>
                            <br/>
                            <a href='https://1lib.in/book/2855973/aaf467'>DSA Made Easy: Data Structures and Algorithmic Puzzles</a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-CSE'>
                <div className='flip-card-inner-CSE'>
                    <div className='flip-card-front-CSE'>
                    <br/>
                        <h1>
                            Database Management System
                        </h1>
                    </div>
                    <div class="flip-card-back-CSE">
                        <h3>
                        
                            <a href='https://www.youtube.com/watch?v=eTiP-H9GQ30&list=PLmXKhU9FNesR1rSES7oLdJaNFgmuj0SYV'>Video Resource 1</a>
                            <br/>
                            <a href='https://www.youtube.com/watch?v=fHAfc7Hjq28&list=PLWPirh4EWFpGrpcMfZ6UcdI786QdtSxV8'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://1lib.in/book/765030/c56b4f'>Distributed Data-base Management Systems</a>
                            <br/>
                            <a href='https://1lib.in/book/2128066/3bd143'>Data Base Management: Theory and Applications</a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-CSE'>
                <div className='flip-card-inner-CSE'>
                    <div className='flip-card-front-CSE'>
                        <h1>
                        <br/>
                            Operating System
                        </h1>
                    </div>
                    <div class="flip-card-back-CSE">
                        <h3>
                            <a href='https://www.youtube.com/watch?v=bkSWJJZNgf8&list=PLxCzCOWd7aiGz9donHRrE9I3Mwn6XdP8p'>Video Resource 1</a>
                            <br/>
                            <a href='https://www.youtube.com/watch?v=vBURTt97EkA&list=PLBlnK6fEyqRiVhbXDGLXDk_OQAeuVcp2O'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://1lib.in/book/3509014/456f35'>Operating System Concepts</a>
                            <br/>
                            <a href='https://1lib.in/book/2485331/e2d1cb'>Linux Command Line and Shell Scripting Bible</a>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
     
        </div>
    )
}

export default CS
